import { Grid, Typography, TextField, Button } from "@mui/material";
import { ThreeDots } from "react-loader-spinner";
import React from "react";

export default function SignatureLimitSection({
  signatureLimit,
  handleOnChangeSignatureLimit,
  handleSaveSignatureLimit,
  isConfiguringSignatureLimit,
}) {
  return (
    <Grid container sx={{ ml: 2, mt: "16px" }}>
      <Grid
        container
        xs={12}
        sm={12}
        md={12}
        lg={12}
        xl={12}
        sx={{ alignSelf: "center", display: "flex", mt: 1 }}
      >
        <Grid item xs={6} sm={6} md={4} lg={4} xl={4} sx={{ alignSelf: "center" }}>
          <Typography sx={{ fontWeight: "bold", alignSelf: "center", fontSize: 14 }}>
            Set Signature Limit
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6} md={6}>
          <Grid container spacing={1} alignItems="flex-start" sx={{ alignItems: "center" }}>
            <Grid item>
              <TextField
                size="small"
                type="number"
                value={signatureLimit}
                onChange={handleOnChangeSignatureLimit}
                inputProps={{ min: 0, max: 10 }}
                sx={{ "& .MuiInputBase-root": { height: 32, width: 75 } }}
              />
            </Grid>
            <Grid item>
              <Button
                startIcon={
                  isConfiguringSignatureLimit && (
                    <ThreeDots height="20" width="20" radius="9" color="#0178f2" />
                  )
                }
                onClick={handleSaveSignatureLimit}
                sx={{ textTransform: "none" }}
                variant="contained"
                size="small"
              >
                {isConfiguringSignatureLimit ? "Saving" : "Save"}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
